export default __webpack_public_path__ + "static/kurorty-img-7-815c12363f2aa882b40699e2ac3c8a44.png";